import * as React from "react";
import "intersection-observer";
import {Action, IOWidget, mk_widget} from "widgets-for-react";
import {CMSState} from "../../../../cms/blocks/types.gen";
import {PublicSite_CustomPageData} from "../../../application.mod";

export type OtherThemesBlockProps<CustomBlockData, extra_images> = {
  title?: string;
  grid_items: GridItems[]; // this list will at most contain 2 items
};
interface GridItems {
  has_link: boolean;
  link_text: string;
  link_url: string;
  image_id: number;
  image_url: string;
  // image_alt: string;
  title: string;
  label: string;
}

export type OtherThemesBlockStyle = Partial<{}>;

export function OtherThemesBlock<customBlockData, extra_images>(
  props: OtherThemesBlockProps<customBlockData, extra_images>,
  options?: {style?: OtherThemesBlockStyle; key?: string}
): IOWidget<
  CMSState<customBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<customBlockData, extra_images, never>>
> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: (_) => {
        return (
          <section className="block block--themes background background--left">
            <div className="block__inner container--xl grid--block">
              {props.title && (
                <header className="block__header">
                  <h2 className="block__title typo--3xl">{props.title}</h2>
                </header>
              )}

              <div className="block__content">
                <ul className="block__list">
                  {props.grid_items.map((item) => (
                    <li className="block__item item">
                      {item.has_link ? (
                        <a className="item__link" href={item.link_url}>
                          <article className="item__inner">
                            <div className="item__header">
                              {item.title && (
                                <h3 className="item__title typo--l">
                                  {item.title}
                                  <svg className="item__icon" width="22px" height="18px">
                                    <use xlinkHref="#arrow--right" />
                                  </svg>
                                </h3>
                              )}
                              {item.label && <span className="item__label typo--3xs">{item.label}</span>}
                            </div>
                            {item.image_url && (
                              <div className="item__visual">
                                <img
                                  className="item__image"
                                  src={item.image_url}
                                  // alt={item.image_alt}
                                />
                              </div>
                            )}
                          </article>
                        </a>
                      ) : (
                        <article className="item__inner">
                          <div className="item__header">
                            {item.title && (
                              <h3 className="item__title typo--l">
                                {item.title}
                                <svg className="item__icon" width="22px" height="18px">
                                  <use xlinkHref="#arrow--right" />
                                </svg>
                              </h3>
                            )}
                            {item.label && <span className="item__label typo--3xs">{item.label}</span>}
                          </div>
                          {item.image_url && (
                            <div className="item__visual">
                              <img
                                className="item__image"
                                src={item.image_url}
                                // alt={item.image_alt}
                              />
                            </div>
                          )}
                        </article>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        );
      }
    });
}
